import createCache from '@emotion/cache';
import { getCspNonce } from './shared/utils/cspNonce';

export default function createEmotionCache() {
  // Force speedy mode (CSSOM insertRule) in all environments.
  // In speedy mode, Emotion creates <style> elements with EMPTY text content
  // and injects rules via sheet.insertRule() — never inline text.
  //
  // CSP Nonce Strategy:
  // - Tenta usar nonce dinâmico gerado pelo servidor (método seguro)
  // - Se não disponível, usa SHA-256 de string vazia como fallback
  const nonce = getCspNonce();

  const cacheConfig: any = { key: 'css', speedy: true };

  // Aplicar nonce ao Emotion se disponível
  if (nonce) {
    cacheConfig.nonce = nonce;
  }

  return createCache(cacheConfig);
}
